import React from 'react'
import ScrollTo from "react-scroll-into-view";
import { motion } from "framer-motion";
import { MDBBtn } from 'mdb-react-ui-kit';
import NavigationButton from './NavigationButton';

const Hero = () => {
  return (
    <motion.div initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.2, duration: 2}} >
          <section id="hero" className="section-image-bg">
              <div className="row section-full-frame section-diviser">
                  <div className="col-sm-12 d-flex flex-column justify-content-end align-items-center">
                      <h1 className="title display-2">The Perfect Getaway</h1>
                      <NavigationButton mySelector="#intro" myIcon="chevron-down" hasMargin={false}/>
                  </div>
                  <div className="col-sm-12 d-flex justify-content-center align-items-center">
                    <ScrollTo selector="#contacts">
                        <MDBBtn outline rounded className='mx-2 social-button' color='secondary'>
                            Contacts
                        </MDBBtn>
                    </ScrollTo>
                </div>
              </div> 
          </section>
        </motion.div>
  )
}

export default Hero